import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'js-cookie';
import supabase from '../supabase';

const initialState = {
  authenticated: false,
  isAdmin: false,
  username: ""
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const expirationDate = new Date(); // Calcula la fecha de vencimiento
      expirationDate.setMinutes(expirationDate.getMinutes() + Number(process.env.REACT_APP_USER_ACTIVITY_MINUTES));
      Cookies.set('authenticated', "true", { expires: expirationDate });
      const data = {
        value : "true",
        expiration: expirationDate,
      };
      sessionStorage.setItem("onSession", JSON.stringify(data));
      sessionStorage.setItem("authenticated", JSON.stringify(data));
      sessionStorage.setItem("isAdmin", action.payload.isAdmin ? 'true' : 'false');
      return {
        ...state,
        authenticated: true,
        isAdmin : action.payload.isAdmin,
        username : action.payload.username
    }},
    logout: (state) => {
      Cookies.remove('authenticated') 
      Cookies.remove('onSession')
      sessionStorage.removeItem("authenticated") 
      sessionStorage.removeItem("onSession") 
      sessionStorage.removeItem("isAdmin") 
      return{
        ...state,
        authenticated : false,
        isAdmin : false,
        username : ""
    }}
  },
})

// Action creators are generated for each case reducer function
export const { login, logout } = authSlice.actions

export default authSlice.reducer